import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const directoryGroupsApi = createApi({
  reducerPath: 'directoryGroupsApi',
  baseQuery: createBaseQuery('directory_groups'),
  tagTypes: ['DirectoryGroup'],
  endpoints: builder => ({
    getDirectoryGroups: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
      providesTags: ['DirectoryGroup'],
    }),
    updateDirectoryGroupMapping: builder.mutation({
      query: ({ workosGroupId, data }) => ({
        url: `/${workosGroupId}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['DirectoryGroup'],
    }),
  }),
});

export const { useGetDirectoryGroupsQuery, useUpdateDirectoryGroupMappingMutation } =
  directoryGroupsApi;
